import { Heading } from "@chakra-ui/react";
import { getLayout } from "components/Layout/BrandSettings";
import HeadTitle from "components/Shared/HeadTitle";
import BrandSettingsForm from "components/Core/AccountInfo/BrandSettingsForm";
import Well from "components/Shared/Well";
import { useCurrentBrandId } from "utils/currentUserHooks";
import { useBrandQuery } from "utils/apollo/hooks/brand";
import { gql } from "__generated__/gql";
import BrandEmails from "components/Shared/BrandEmails";

const query = gql(/* GraphQL */ `
  query BrandSettings($brandId: UUID!) {
    brand(id: $brandId) {
      id
      ...BrandSettingsFields
      ...BrandEmailsFields
    }
  }
`);

export default function BrandSettingsIndex() {
  const brandId = useCurrentBrandId();

  const { data, loading: isLoading } = useBrandQuery(query, {
    variables: brandId ? { brandId } : undefined,
    skip: !brandId,
  });

  return (
    <>
      <HeadTitle title="Brand Details" />
      <Heading as="h1" variant="section-header" marginBottom=".75em">
        Brand Details
      </Heading>

      <BrandSettingsForm brand={data?.brand} isLoading={isLoading} />

      <Well mt={10} pb={0} borderRadius="md">
        <Heading as="h2" size="sm" color="magenta.veryDark">
          Brand Email Addresses
        </Heading>
        <BrandEmails brand={data?.brand} />
      </Well>
    </>
  );
}

BrandSettingsIndex.getLayout = getLayout;
